// import Jobposition from "./api/Jobposition/Jobposition.js";

export default {
  // ...Jobposition,
};
